export const
    abj_publication = require('./abj_publication.png'),
    ainno_publication = require('./ainno_publication.png'),
    cbs_publication = require('./cbs_publication.png'),
    fb_publication = require('./fb_publication.png'),
    fb_stars = require('./fb_stars.png')